module.exports = __webpack_public_path__ + "static/image_1-11021bfbe39c3eefd2197d6522f6bfff.jpg";